/*
 * sidebar (config)
 */
// import type { SidebarGroup } from "@psychology/react-components/server"
import type { AuthUser } from "@psychology/types"
import { isAdmin } from "@psychology/utils"
import {
	Info,
	LayoutDashboard,
	Shield,
	SquareTerminal,
	User as UserIcon,
} from "lucide-react"
import { getEnabledFeatures } from "./features"

type TranslateFn = (key: string) => string

export function getSidebarMenuList(
	user?: AuthUser | null,
	devMode?: boolean,
	t: TranslateFn = (key) => key,
): any[] {
	const dashboardGroup = {
		groupLabel: "",
		menus: [
			{
				to: "/dashboard",
				label: "Dashboard",
				icon: LayoutDashboard,
			},
		],
	}

	// Add intake link at top if user has no profile
	// if (!psychologyFlags?.hasProfile) {
	// 	dashboardGroup.menus.push({
	// 		to: "/intake",
	// 		label: "Profile Intake",
	// 		icon: FileText,
	// 	})
	// }

	const menuList = [
		dashboardGroup,
		getMainMenuList(t, devMode),
		getBottomMenuList(user, devMode),
	].filter((group) => group)

	return menuList
}

/*
 * main
 */
function getMainMenuList(t: TranslateFn, devMode?: boolean) {
	const options: any = {
		groupLabel: "Services",
		menus: getEnabledFeatures({ devMode }).map((feature) => ({
			label: t(feature.titleKey),
			icon: feature.icon,
			to: feature.to,
			Badge: feature.Badge,
		})),
	}

	return options
}

/*
 * bottom
 */
function getBottomMenuList(user?: AuthUser | null, devMode?: boolean) {
	const settings: any = { groupLabel: "Settings", menus: [] }

	if (user) {
		// Account
		settings.menus.push({
			to: "/auth/account",
			label: "Account",
			icon: UserIcon,
		})

		// Admin
		if (isAdmin(user)) {
			settings.menus.push({
				to: "/auth/admin",
				label: "Admin",
				icon: Shield,
			})
		}
	}

	// Dev
	if (devMode) {
		settings.menus.push({
			to: "/dev",
			label: "Dev",
			icon: SquareTerminal,
		})
	}

	// Legal
	// settings.menus.push({
	// 	to: "/legal",
	// 	label: "Legal",
	// 	icon: Scale,
	// })

	// About
	settings.menus.push({
		to: "/about",
		label: "About",
		icon: Info,
	})

	return settings
}
